import { Animation, AnimationBuilder, createAnimation } from '@ionic/angular';

const buildSequentialFadeAnimation = (opts: any, leaveDuration: number, enterDuration: number, easing: string): Animation => {
    const enteringEl = opts?.enteringEl;
    const leavingEl = opts?.leavingEl;
    const root = createAnimation().duration(leaveDuration + enterDuration).easing(easing);

    if (enteringEl) {
        const entering = createAnimation()
            .addElement(enteringEl)
            .beforeRemoveClass('ion-page-invisible')
            .beforeStyles({ opacity: '0' })
            .delay(leaveDuration)
            .duration(enterDuration)
            .fromTo('opacity', '0', '1')
            .afterStyles({ opacity: '1' })
            .afterClearStyles(['opacity']);

        root.addAnimation(entering);
    }

    if (leavingEl) {
        const leaving = createAnimation()
            .addElement(leavingEl)
            .duration(leaveDuration)
            .fromTo('opacity', '1', '0')
            .afterClearStyles(['opacity']);

        root.addAnimation(leaving);
    }

    return root;
};

// Preset 1: fade out current page first, then fade in next page
export const stableNavAnimation: AnimationBuilder = (_baseEl: any, opts?: any): Animation =>
    buildSequentialFadeAnimation(opts, 120, 140, 'cubic-bezier(0.22, 1, 0.36, 1)');

// Preset 2: a bit slower
export const slideNavAnimation: AnimationBuilder = (_baseEl: any, opts?: any): Animation =>
    buildSequentialFadeAnimation(opts, 150, 170, 'cubic-bezier(0.22, 1, 0.36, 1)');

// Preset 3: faster fade
export const fastNavAnimation: AnimationBuilder = (_baseEl: any, opts?: any): Animation =>
    buildSequentialFadeAnimation(opts, 90, 110, 'linear');

// Backward-compatible alias for older imports/cached builds
export const fadeNavAnimation = stableNavAnimation;
export const smoothNavAnimation = stableNavAnimation;
